import Vue from 'vue'
import Router from 'vue-router'
import _import from "@/js/import";

import Login from '@/page/PageLogin.vue';

const Layout = _import("layout/Layout");
const container = _import("vContainer/vContainer", "component");

Vue.use(Router)


// 所有权限通用路由表
// 如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "登录",
    component: Login
  }
];

// 实例化vue的时候只挂载constantRouter
export default new Router({
  routes: constantRouterMap
});

// 异步挂载的路由
// 动态需要根据权限加载的路由表
export const asyncRouterMap = [
  {
    path: "/goods",
    redirect: "/goods/goodsManage",
    name: "goods",
    title: "商品",
    isMenu: true,
    component: Layout,
    meta: {
      roles: ['community', 'common'],
      icon: 'qj-icon-money'
    },
    children: [
      {
        path: "/goods/goodsManage",
        name: "goods-manage",
        title: "商品管理",
        component: () => import('@/page/goods/goods-manage.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
      {
        path: "/goods/groupManage",
        name: "group-edit",
        title: "商品分组",
        component: () => import('@/page/goods/goods-group.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
      {
        path: "/goods/stepManage",
        name: "step-edit",
        title: "使用步骤",
        component: () => import('@/page/goods/goods-step.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      }
    ]
  },
  {
    path: "/order",
    redirect: "/order/orderManage",
    name: "order",
    title: "订单",
    isMenu: true,
    component: Layout,
    meta: {
      roles: ['community', 'common'],
      icon: 'qj-icon-phone'
    },
    children: [{
      path: "/order/orderManage",
      name: "orderManage",
      title: "订单管理",
      component: () => import('@/page/order/orderManage.vue'),
      meta: {
        roles: ['community', 'common'],
        icon: 'qj-icon-edit'
      }
    }]
  },
  {
    path: "/distribution",
    redirect: "/order/orderManage",
    name: "distribution",
    title: "分销",
    isMenu: true,
    component: Layout,
    meta: {
      roles: ['community', 'common'],
      icon: 'qj-icon-guanli'
    },
    children: [
      {
        path: '/distribution/makeCashCheck',
        name: 'makeCashCheck',
        title: "提现审核",
        component: () => import('@/page/distribution/makeCashCheck.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
      {
        path: '/distribution/distributorCheck',
        name: 'distributorCheck',
        title: "分销者审核",
        component: () => import('@/page/distribution/distributorCheck.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
      {
        path: '/distribution/distributorList',
        name: 'distributorList',
        title: "分销者数据",
        component: () => import('@/page/distribution/distributorList.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
      {
        path: '/distribution/beneficiaryManage',
        name: 'beneficiaryManage',
        title: "受益人管理",
        component: () => import('@/page/distribution/BeneficiaryManage.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
      {
        path: '/distribution/commissionSystem',
        name: 'commissionSystem',
        title: "佣金体系",
        component: () => import('@/page/distribution/CommissionSystem.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
      {
        path: '/distribution/distributorSettleList',
        name: 'distributorSettleList',
        title: "分销数据变动明细",
        component: () => import('@/page/distribution/distributorSettleList.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
      {
        path: '/distribution/deliveryCount',
        name: 'deliveryCount',
        title: "发货统计",
        component: () => import('@/page/distribution/deliveryCount.vue'),
        meta: {
          roles: ['community', 'common'],
          icon: 'qj-icon-edit'
        }
      },
    ]
  },
  {
    path: "/404",
    name: "页面不存在",
    component: resolve => require(['@/page/common/404.vue'], resolve)
  },
  {path: '*', redirect: '/404', hidden: true}
];



// WEBPACK FOOTER //
// ./src/router/index.js